export function scrollToHash(hash: string) {
  const element = document.querySelector(`#${hash}`);
  if (!element) return;

  const topPos = element.getBoundingClientRect().top + window.pageYOffset;

  window.scrollTo({
    top: topPos,
    behavior: 'smooth',
  });
}
